// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".F3Xe\\+ {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n  .RJTmG {\n    height: 100%;\n    max-height: 100vh;\n    margin-bottom: 20px;\n    border: 1px solid rgb(var(--color-light-gray-3));\n  }\n\n  .Ty3E4 {\n    margin-bottom: 10px;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PublishedTable": "F3Xe+",
	"PublishedTable_tablesGrid": "RJTmG",
	"PublishedTable_headingContainer": "Ty3E4"
};
export default ___CSS_LOADER_EXPORT___;
